import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-trip-detail-breadcrumb-card',
  templateUrl: './mcommerce-trip-detail-breadcrumb-card.component.html',
  styleUrls: ['./mcommerce-trip-detail-breadcrumb-card.component.scss']
})
export class McommerceTripDetailBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
